module.exports = {"130121100":"微水镇","130121101":"上安镇","130121102":"天长镇","130121103":"秀林镇","130121104":"南峪镇","130121105":"威州镇","130121106":"小作镇","130121107":"南障城镇","130121108":"苍岩山镇","130121109":"测鱼镇","130121200":"吴家窑乡","130121201":"北正乡","130121202":"于家乡","130121203":"孙庄乡","130121204":"南陉乡","130121205":"辛庄乡","130121206":"南王庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130121.json
// module id = 65
// module chunks = 0